import {Controller} from "@hotwired/stimulus";

export default class extends Controller
{
    static targets = ['checkboxContainer'];

    connect() {
        this.checkboxContainerTargets.forEach((checkboxContainer) => {
            checkboxContainer.addEventListener('click', () => {
                const checkbox = checkboxContainer.querySelector('div');
                checkbox.classList.toggle('w--redirected-checked');
                const input = checkboxContainer.querySelector('input');
                input.checked = !input.checked;
            })
        });
    }
}